module.exports = __webpack_public_path__ + "static/media/rober3.abed9c69.jpg";